import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import ActionThemes from 'automation-ui-flow-core/canvas/ActionThemes';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_CONTAINER_SIZE_RATIO = 0.6;
const IconContainer = styled.div.withConfig({
  displayName: "ActionIcon__IconContainer",
  componentId: "sc-1uuz19z-0"
})(["width:", "px;height:", "px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:2px solid transparent;"], ({
  size
}) => size, ({
  size
}) => size);
const Image = styled.img.withConfig({
  displayName: "ActionIcon__Image",
  componentId: "sc-1uuz19z-1"
})(["object-fit:contain;"]);

// The icon font tends to sit too high, which is distracting in this context
const Icon = styled(UIIcon).withConfig({
  displayName: "ActionIcon__Icon",
  componentId: "sc-1uuz19z-2"
})(["margin-top:1px;"]);
function ActionIcon({
  use = 'default',
  name = 'question',
  // The url of an extension action's icon, if applicable
  src,
  // Alt text for the extension action's icon
  alt,
  // The size of the icon itself, the circle will always be larger by an inverse factor of ICON_CONTAINER_SIZE_RATIO
  size = 24,
  className,
  showCircle = true
}) {
  const {
    iconColor,
    headerBackgroundColor
  } = ActionThemes[use];
  let icon;
  if (src) {
    icon = /*#__PURE__*/_jsx(Image, {
      src: src,
      alt: alt,
      height: size,
      width: size
    });
  } else {
    icon = /*#__PURE__*/_jsx(Icon, {
      name: name,
      size: size,
      color: iconColor || undefined
    });
  }
  if (showCircle) {
    return /*#__PURE__*/_jsx(IconContainer, {
      className: className,
      size: Math.round(size / ICON_CONTAINER_SIZE_RATIO),
      style: {
        backgroundColor: headerBackgroundColor || undefined,
        borderColor: iconColor || undefined
      },
      children: icon
    });
  } else {
    return /*#__PURE__*/_jsx("div", {
      className: className,
      children: icon
    });
  }
}
ActionIcon.propTypes = {
  use: PropTypes.string,
  name: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
};
export default ActionIcon;